var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-content-layout',{staticClass:"invoicing",attrs:{"title":"Fakturering"}},[(false)?_c('button-view',{attrs:{"slot":"tools","label":"Opret"},slot:"tools"}):_vm._e(),(false)?_c('button-group-view',{attrs:{"slot":"tools","actions":[
		{
			label: 'Modtaget',
			value: 'received'
		},
		{
			label: 'Åben',
			value: 'open'
		},
		{
			label: 'Lukket',
			value: 'closed'
		}
	]},slot:"tools",model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}}):_vm._e(),(_vm.checked.length > 0)?_c('button-view',{attrs:{"slot":"tools","label":"Marker som faktureret"},on:{"click":_vm.invoiced},slot:"tools"}):_vm._e(),(_vm.checked.length > 0)?_c('button-view',{attrs:{"slot":"tools","label":"Fakturer"},on:{"click":_vm.select},slot:"tools"}):_vm._e(),_c('new-table-view',{ref:"table",attrs:{"columns":[
	{
			label: 'Oprettet',
			name: 'created',
			filter: 'date',
			weight: 2
		},
		{
			label: 'Ordrenr.',
			name: 'num',
			weight: 2
		},
		{
			label: 'Kunde',
			name: ['customer', 'name'],
			weight: 3
		},
		{
			label: 'Beløb',
			name: ['_calculated', 'total'],
			align: 'right',
			filter: 'number',
			weight: 2
		},
		{
			label: 'Bemærkninger',
			name: 'remarks',
			weight: 5
		}
	],"items":_vm._items},on:{"itemClick":_vm.itemClick,"context":_vm.itemContext},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }